import { createReducer } from 'redux-act'

import { fulfilled, rejected } from '../../helpers/reducerPromiseHelper'

import {
  getSalesSummaryByPOS,
} from './actions'

const initialState = {
  salesSummary: {}
}

export default createReducer({
  [fulfilled(getSalesSummaryByPOS)]: (state, payload) => ({
    ...state,
    salesSummary: payload.data.data
  }),

  [rejected(getSalesSummaryByPOS)]: (state, payload) => ({
    ...state,
    salesSummary: { ...initialState.salesSummary }
  }),
}, { ...initialState })
